/* MoanSpeak: mouse dragging for the closed Chatty launcher. 2026-10-07.
   Position stays in this browser tab/session. No requests or customer data. */
(() => {
  'use strict';
  const styleId = 'moanspeak-chat-drag-styles';
  if (document.getElementById(styleId)) return;
  const selector = '#Avada-FAQ_WidgetTrigger';
  const storageKey = 'moanspeak-chat-position-v1';
  const desktop = window.matchMedia('(min-width: 768px) and (any-pointer: fine)');
  const margin = 8;
  let button, wrapper, gesture, position, suppressClick;
  let resizeFrame = 0;
  try {
    const saved = JSON.parse(sessionStorage.getItem(storageKey));
    if (saved && Number.isFinite(saved.x) && Number.isFinite(saved.y)) {
      position = { x: Math.max(0, Math.min(1, saved.x)), y: Math.max(0, Math.min(1, saved.y)) };
    }
  } catch (_) { /* Storage may be unavailable; dragging still works. */ }

  const style = document.createElement('style');
  style.id = styleId;
  style.textContent = `
    @media (min-width: 768px) and (any-pointer: fine) {
      #Avada-FAQ_WidgetTrigger[aria-expanded="false"] { cursor: grab !important; user-select: none; }
      #Avada-FAQ_WidgetTrigger[aria-expanded="false"] img { -webkit-user-drag: none !important; }
      #Avada-FAQ_Widget .Avada-Faqs_Button[data-ms-chat-position]:has(#Avada-FAQ_WidgetTrigger[aria-expanded="false"]) {
        position: fixed !important;
        left: var(--ms-chat-x) !important;
        top: var(--ms-chat-y) !important;
        right: auto !important;
        bottom: auto !important;
        margin: 0 !important;
        transform: none !important;
        transition: none !important;
        animation: none !important;
      }
      #Avada-FAQ_WidgetTrigger[data-ms-chat-dragging] { cursor: grabbing !important; }
    }
  `;
  document.head.appendChild(style);

  function bounds() {
    return {
      x: Math.max(0, document.documentElement.clientWidth - wrapper.offsetWidth - margin * 2),
      y: Math.max(0, document.documentElement.clientHeight - wrapper.offsetHeight - margin * 2)
    };
  }
  function applyPosition() {
    if (!wrapper || !position || !desktop.matches) return;
    const area = bounds();
    wrapper.style.setProperty('--ms-chat-x', (margin + position.x * area.x) + 'px');
    wrapper.style.setProperty('--ms-chat-y', (margin + position.y * area.y) + 'px');
    wrapper.setAttribute('data-ms-chat-position', '');
  }
  function moveTo(x, y) {
    const area = bounds();
    position = {
      x: area.x ? Math.max(0, Math.min(1, (x - margin) / area.x)) : 0,
      y: area.y ? Math.max(0, Math.min(1, (y - margin) / area.y)) : 0
    };
    applyPosition();
  }
  function finish(cancelled) {
    if (!gesture) return;
    const previous = gesture;
    gesture = null;
    previous.button.removeAttribute('data-ms-chat-dragging');
    if (!previous.moved) return;
    suppressClick = { button: previous.button, until: performance.now() + 700 };
    if (cancelled) {
      position = previous.position;
      if (position) applyPosition();
      else wrapper.removeAttribute('data-ms-chat-position');
    } else {
      try { sessionStorage.setItem(storageKey, JSON.stringify(position)); } catch (_) { /* Optional persistence. */ }
    }
  }
  function attach() {
    const next = document.querySelector(selector);
    if (!next || next === button) return;
    if (gesture) finish(true);
    button = next;
    wrapper = next.closest('.Avada-Faqs_Button');
    if (!wrapper) return;
    applyPosition();
    next.addEventListener('mousedown', event => {
      if (event.button !== 0 || !desktop.matches || next.getAttribute('aria-expanded') !== 'false') return;
      event.preventDefault();
      suppressClick = null;
      const rect = wrapper.getBoundingClientRect();
      gesture = { button: next, x: event.clientX, y: event.clientY,
        left: rect.left, top: rect.top, moved: false, position: position ? { ...position } : null };
    });
    next.addEventListener('dragstart', event => {
      if (gesture) event.preventDefault();
    });
  }
  window.addEventListener('mousemove', event => {
    if (!gesture) return;
    if (!(event.buttons & 1) || !desktop.matches) { finish(false); return; }
    const dx = event.clientX - gesture.x;
    const dy = event.clientY - gesture.y;
    if (!gesture.moved && Math.hypot(dx, dy) < 6) return;
    if (!gesture.moved) {
      gesture.moved = true;
      gesture.button.setAttribute('data-ms-chat-dragging', '');
    }
    event.preventDefault();
    moveTo(gesture.left + dx, gesture.top + dy);
  }, { capture: true, passive: false });
  window.addEventListener('mouseup', () => finish(false), true);
  window.addEventListener('blur', () => finish(false));
  window.addEventListener('keydown', event => { if (event.key === 'Escape') finish(true); }, true);
  window.addEventListener('click', event => {
    if (suppressClick && performance.now() < suppressClick.until && suppressClick.button.contains(event.target)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      suppressClick = null;
    }
  }, true);
  function resize() {
    if (gesture) finish(true);
    cancelAnimationFrame(resizeFrame);
    resizeFrame = requestAnimationFrame(applyPosition);
  }
  window.addEventListener('resize', resize, { passive: true });
  desktop.addEventListener('change', resize);
  attach();
  new MutationObserver(attach).observe(document.body, { childList: true, subtree: true });
})();
